import './App.scss';
import TestMessage from 'components/test-message';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Paths } from 'config/routes';
import NotFound from 'pages/not-found/not-found';
import Auth from 'pages/auth';
import RedirectParent from 'pages/redirect-parent';
import Checkout from 'pages/checkout';
import ShopifyStatus from 'pages/shopify-status';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useAppSelector } from 'app/hooks';
import { selectLanguage } from 'features/payment/payment-slice';

function App() {
  const { i18n } = useTranslation();
  const language = useAppSelector(selectLanguage);

  useEffect(() => {
    if (language) i18n.changeLanguage(language);
  }, [language]);

  return (
    <div className="App">
      <TestMessage />
      <BrowserRouter>
        <Routes>
          <Route path={Paths.VALIDATE} element={<Auth />} />
          <Route path={Paths.CHECKOUT} element={<Checkout />} />
          <Route path={Paths.SHOPIFY_STATUS} element={<ShopifyStatus />} />
          <Route path={Paths.REDIRET_PARENT} element={<RedirectParent />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
